import { ReactElement } from 'react'
import { ProjectImplementationDetailsIndex } from 'src/screens/shared/implementation/details/ProjectImplementationDetailsIndex'

export const PfPgvImplementationDetailsIndexPage = (): ReactElement => {
  return <ProjectImplementationDetailsIndex baseUrl="/pf-pgv" />
}
